"use client";

import { c as _c } from "react/compiler-runtime";
import { Divider } from "antd";
import styles from "./page.module.sass";
import Giscus from "@giscus/react";
import { useLocale, useTranslations } from "next-intl";
export default function GuestbookPage(_props) {
  const $ = _c(10);
  const t = useTranslations("guestbook");
  const locale = useLocale();
  const giscusLang = locale === "zh-Hans" ? "zh-CN" : locale === "zh-Hant" ? "zh-TW" : "en";
  let t0;
  if ($[0] !== t) {
    t0 = t("title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h1 className={styles.title}>{t0}</h1>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Divider data-sentry-element="Divider" data-sentry-source-file="page.tsx" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== giscusLang) {
    t3 = <Giscus id="comments" repo="cw1997/www.changwei.me" repoId="R_kgDOLLaI-Q" category="Announcements" categoryId="DIC_kwDOLLaI-c4Cgdw4" mapping="pathname" reactionsEnabled="1" emitMetadata="0" inputPosition="top" theme="light" lang={giscusLang} loading="lazy" data-sentry-element="Giscus" data-sentry-source-file="page.tsx" />;
    $[5] = giscusLang;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <div className={styles.container} data-sentry-component="GuestbookPage" data-sentry-source-file="page.tsx"><main>{t1}{t2}{t3}</main></div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}